import { Button } from '@design-system/components/button/button';
import { Input } from '@design-system/components/input/input';
import { Typography } from '@design-system/components/typography/typography';
import { useState } from 'react';
import { nameWrapper } from './EditName.css';
import { clsx } from 'clsx';

const RestoreName = ({ onClick }: { onClick: () => void }) => (
  <Button
    variant="text"
    color="neutral"
    onClick={onClick}
    className="p-1 w-[150px]"
  >
    Restore
  </Button>
);

export const EditName = ({
  name,
  setNewName,
  reset,
  error,
  setError,
}: {
  name: string;
  setNewName: (value: string) => void;
  reset: () => void;
  error?: string;
  setError: (value?: string) => void;
}) => {
  const [editMode, setEditMode] = useState(false);

  const onKeyDown = (key: string) => {
    if (key === 'Enter') {
      if (!name) {
        setError('Video title cannot be left empty');
        return;
      }
      setEditMode(false);
    }
    if (key == 'Escape') {
      restoreName();
    }
  };

  const restoreName = () => {
    reset();
    setEditMode(false);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(undefined);
    setNewName(e.target.value);
  };

  return (
    <>
      <div
        className={clsx('w-full', editMode && 'inline', !editMode && 'hidden')}
      >
        <Input
          onKeyDown={(e) => onKeyDown(e.key)}
          value={name}
          onChange={onChange}
          error={error}
          endCta={<RestoreName onClick={restoreName} />}
        />
      </div>
      <div
        className={clsx(!editMode && 'flex', editMode && 'hidden', nameWrapper)}
        onClick={() => setEditMode(true)}
      >
        <Typography variant="body">{name}</Typography>
      </div>
    </>
  );
};
